module.exports = __webpack_public_path__ + "static/media/banner.e3618742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = 36
// module chunks = 0